import { render } from "./CollaboratorsEditView.vue?vue&type=template&id=b0411be2"
import script from "./CollaboratorsEditView.vue?vue&type=script&lang=js"
export * from "./CollaboratorsEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__